import '@formatjs/intl-enumerator/polyfill'
import 'core-js/features/string/replace-all'

import App from './components/App'
import Embed from './components/Embed'
import React from 'react'
import {createRoot} from 'react-dom/client'
import {getEnvironment} from './appconfig'

const {target} = getEnvironment()

createRoot(document.getElementById('root') as HTMLElement).render(target === 'app' ? <App /> : <Embed />)
